var swiper = new Swiper(".section-hero .swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoHeight: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 9000,
        disableOnInteraction: false,
    },
});

var swiperDestinations = new Swiper(".destinations-swiper", {
    slidesPerView: 1.25,
    spaceBetween: 16,
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination",
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
        1440: {
            slidesPerView: 5,
        },
    },
});

document.addEventListener('DOMContentLoaded', function () {
    const tabLinks = document.querySelectorAll('.custom-tabs .tabs-filter-link');
    const tabContents = document.querySelectorAll('.custom-tabs .custom-tabs-content-each');
    let maxHeight = 0;

    tabLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            tabLinks.forEach(l => l.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));

            this.classList.add('active');

            const targetId = this.getAttribute('data-tab');
            const targetContent = document.querySelector(targetId);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });

    if (tabLinks.length > 0) {
        tabLinks[0].click();
    }

    tabContents.forEach(function (tabContent) {
        const contentHeight = tabContent.offsetHeight;
        if (contentHeight > maxHeight) {
            maxHeight = contentHeight;
        }
    });

    const tabsContainer = document.querySelector('.custom-tabs-content');
    if (tabsContainer) {
        tabsContainer.style.height = maxHeight + 'px';
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const tabLinks = document.querySelectorAll('.custom-tabs .tabs-filter-link');
    const tabContents = document.querySelectorAll('.custom-tabs .custom-tabs-content-each');
    const tabImages = document.querySelectorAll('.what-will-you-get .tab--image'); 
    let maxHeight = 0;

    tabLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            tabLinks.forEach(l => l.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));
            tabImages.forEach(img => img.classList.remove('active')); 

            this.classList.add('active');

            const targetId = this.getAttribute('data-tab');
            const targetContent = document.querySelector(targetId);
            if (targetContent) {
                targetContent.classList.add('active');
            }

            const targetImage = document.querySelector(`#tab-image-${targetId.split('-').pop()}`);
            if (targetImage) {
                targetImage.classList.add('active');
            }
        });
    });

    if (tabLinks.length > 0) {
        tabLinks[0].click();
    }

    tabContents.forEach(function (tabContent) {
        const contentHeight = tabContent.offsetHeight;
        if (contentHeight > maxHeight) {
            maxHeight = contentHeight;
        }
    });

    const tabsContainer = document.querySelector('.custom-tabs-content');
    if (tabsContainer) {
        tabsContainer.style.height = maxHeight + 'px';
    }
});


const siteHeader = document.querySelector(".site-header");
const announcementBar = document.querySelector("#qab_container");

const mediaQueryMax = window.matchMedia("(max-width: 991.98px)");
const mediaQueryMin = window.matchMedia("(min-width: 991.98px)");

if (siteHeader) {
    const navToggler = siteHeader.querySelector(".navbar-toggler");
    const navWrapper = siteHeader.querySelector(".navbar-nav-wrapper");
    const dropdownToggle = siteHeader.querySelectorAll(".dropdown--toggle");
    const dropdownToggleLevel1 = siteHeader.querySelectorAll(".dropdown--toggle-level-1");
    const dropdownToggleLevel2 = siteHeader.querySelectorAll(".dropdown--toggle-level-2");
    const dropdownToggleLevel3 = siteHeader.querySelectorAll(".dropdown--toggle-level-3");
    const dropdownToggleLevel4 = siteHeader.querySelectorAll(".dropdown--toggle-level-4");
    const dropdownToggleLevel5 = siteHeader.querySelectorAll(".dropdown--toggle-level-5");
    const backToggle = siteHeader.querySelectorAll(".back--toggle");

    if (mediaQueryMin.matches) {
        dropdownToggleLevel3.forEach(element => {
            element.addEventListener('click', function (e) {
                dropdownToggleLevel3.forEach(el => {
                    if (el !== this) {
                        el.classList.remove("active");
                        if (el.nextElementSibling) {
                            el.nextElementSibling.classList.remove("open");
                        }
                    }
                });

                this.classList.toggle("active");
                if (this.nextElementSibling) {
                    this.nextElementSibling.classList.toggle("open");
                }

                e.preventDefault();
                e.stopPropagation();
            });
        });
    }


    if (mediaQueryMax.matches) {
        if (navToggler) {
            navToggler.addEventListener('click', function () {
                document.body.classList.toggle("overflow-stopped");
                this.classList.toggle("open");
                if (navWrapper) {
                    navWrapper.classList.toggle("open");
                }
            });
        }

        dropdownToggle.forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.classList.toggle("active");
                if (this.nextElementSibling) {
                    this.nextElementSibling.classList.toggle("open");
                }
            });
        });

        backToggle.forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                const menu = this.closest(".dropdown--menu");
                if (!menu) return;
                menu.classList.toggle("open");
                if (menu.previousElementSibling) {
                    menu.previousElementSibling.classList.toggle("active");
                }
            });
        });

        dropdownToggleLevel1.forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.classList.toggle("active");
                if (this.nextElementSibling) {
                    this.nextElementSibling.classList.toggle("open");
                }
            });
        });

        dropdownToggleLevel2.forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.parentElement.classList.toggle("active");
                if (this.parentElement.nextElementSibling) {
                    this.parentElement.nextElementSibling.classList.toggle("open");
                }
            });
        });

        dropdownToggleLevel3.forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.classList.toggle("active");
                if (this.nextElementSibling) {
                    this.nextElementSibling.classList.toggle("open");
                }
            });
        });

        dropdownToggleLevel4.forEach(element => {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                this.classList.toggle("active");
                if (this.nextElementSibling) {
                    this.nextElementSibling.classList.toggle("open");
                }
            });
        });
    }
}

function addClassOnScroll() {
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    document.body.style.setProperty('--announcement-height', `${announcementBarHeight}px`);
    let announcementHeightValue = 50;

    if (mediaQueryMax.matches) {
        announcementHeightValue = 36;
    }

    if (window.scrollY > announcementHeightValue) {
        if (siteHeader) {
            siteHeader.classList.add("scrolled");
        }
        document.body.classList.add("scrolled");

    } else {
        if (siteHeader) {
            siteHeader.classList.remove("scrolled");
        }
        document.body.classList.remove("scrolled");
    }
}

window.addEventListener("scroll", addClassOnScroll);
window.addEventListener("resize", addClassOnScroll);
window.addEventListener("DOMContentLoaded", addClassOnScroll);

const howDoesItWorkVideo = document.querySelector('.how-does-it-work__video');

if (howDoesItWorkVideo) {
    const video = document.getElementById('how-does-it-work-video');
    const playButton = howDoesItWorkVideo.querySelector('.play--button');
    const pauseButton = howDoesItWorkVideo.querySelector('.pause--button');

    document.querySelector('.video--controls-button').addEventListener('click', function () {

        if (video.paused) {
            video.play();
            howDoesItWorkVideo.classList.add("playing");
        } else {
            video.pause();
            howDoesItWorkVideo.classList.remove("playing");
        }
    });

    howDoesItWorkVideo.addEventListener('mouseleave', function () {
        this.classList.add("leaved");

        if (video.paused) {
            this.classList.remove("leaved");
        }
    });

    howDoesItWorkVideo.addEventListener('mouseover', function () {
        this.classList.remove("leaved");
    });
}